import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { Theme } from 'webapp/enums/enums';

import FormSelectComponent from 'webapp/components/form/select';

import type Block from 'webapp/models-custom/block';
import type VisualizationHorizontalBarChart from 'webapp/models-custom/visualization/horizontal-bar-chart';
import type VisualizationTable from 'webapp/models-custom/visualization/table';

interface Args {
	blockM: Block;
	theme: Theme | string;
}

export default class BlockSettingsMetricSortDataSelectComponent extends Component<Args> {
	get block() {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get visualization() {
		return this.blockSetup.visualization as
			VisualizationTable | VisualizationHorizontalBarChart;
	}

	get selectedSortDataSelectId() {
		return this.visualization.selectedSortDataSelectId;
	}

	get sortDataSelectOptions(): LabelValuePairNumeric[] {
		return this.blockSetup.sortedDataSelectsShown.map((ds) => {
			return {
				value: ds.numericId!,
				label: ds.shownTitle,
			};
		});
	}

	@action
	changeSortDataSelect(sortDataSelectId: number): void {
		this.visualization.setSortDataSelectFrom(sortDataSelectId);
	}
	<template>
		<div class="row">
			<label>Column to sort</label>
			<FormSelectComponent
				name="dataSelect"
				@selected={{this.selectedSortDataSelectId}}
				@options={{this.sortDataSelectOptions}}
				@onChange={{this.changeSortDataSelect}}
				@isNumeric={{true}}
				@isRequired={{true}}
				@theme={{@theme}}
			/>
		</div>
	</template>
}
